
<script setup lang="ts">

import { useStatsStore } from '@/stores/statsStore.ts'
import StatsGraph from './StatsGraph.vue';
import { onMounted } from 'vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import TagButton from '@/components/Elements/Buttons/TagButton.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const statsStore = useStatsStore()

onMounted(() => {
  statsStore.loadStatsForKey(statsStore.selectedKey ?? 'population')
});

</script>

<template>
  <div class="p-2">
    <StandardCard :title="t('statistics.title')" top-padding="0">
      {{ t('statistics.description') }}
    </StandardCard>
    <div class="flex flex-col md:flex-row pt-2">
      <div class="overflow-y-auto">
        <div class="flex flex-col space-y-1 text-xs sm:text-sm font-medium text-metal-300 w-full md:w-56">
          <template v-for="(item, index) in statsStore.statsKeys.values()" :key="item.key">
            <!-- Show group header when the group changes -->
            <div v-if="index === 0 || item.group !== [...statsStore.statsKeys.values()][index - 1].group" class="bg-gradient-to-b from-metal-700 to-metal-800 p-2 rounded">
              {{ t(`statistics.groups.${item.group}`) }}
            </div>

            <!-- Render the item -->
            <TagButton
              :selected="statsStore.selectedKey === item.key"
              @click="statsStore.setSelectedKey(item.key)"
              class="!block w-full !mr-0"
            >
              {{ t(`statistics.stats.${item.key}.label`) }}
            </TagButton>
            <div v-if="statsStore.selectedKey === item.key" class="h-96 block md:hidden bg-metal-950 rounded-lg p-2">
              <StatsGraph />
            </div>
          </template>
        </div>
      </div>
      <div class="flex-grow pt-2 pl-0 md:pl-2 hidden md:block">
        <div class="bg-metal-950 rounded-lg p-4 h-full">
          <StatsGraph />
        </div>
      </div>
  </div>
  </div>
</template>


<style scoped>
/* Custom styling if needed */
</style>
